"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalizedDictionary = exports.Localized = void 0;
var React = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var util_1 = require("./util");
var hook_1 = require("../hook");
var Localized = function (_a) {
    var id = _a.id, defaultValue = _a.defaultValue, variables = _a.variables, children = _a.children;
    var derivedVariables = variables || (0, util_1.extractVariables)(children);
    var derivedDefaultValue = defaultValue || (0, util_1.extractDefaultValue)(children);
    var _b = (0, react_i18next_1.useTranslation)(), translate = _b.t, i18n = _b.i18n;
    var namespace = (0, hook_1.useNamespace)();
    if (children instanceof Array || React.isValidElement(children)) {
        return (React.createElement(react_i18next_1.Trans, { t: function (id, opts) {
                return translate(id, __assign({ i18n: i18n }, (typeof opts === 'object' ? opts : {})));
            }, ns: namespace, i18nKey: id, defaults: derivedDefaultValue, children: children, components: children instanceof Array ? children : [children], values: derivedVariables }));
    }
    if (children instanceof Function) {
        return (React.createElement(React.Fragment, null, children(translate(id, __assign({ defaultValue: derivedDefaultValue, i18n: i18n, ns: namespace }, derivedVariables)))));
    }
    return React.createElement(React.Fragment, null, translate(id, __assign({ defaultValue: derivedDefaultValue, i18n: i18n, ns: namespace }, derivedVariables)));
};
exports.Localized = Localized;
var LocalizedDictionary = function (_a) {
    var idsAndDefaultValues = _a.idsAndDefaultValues, variables = _a.variables, children = _a.children;
    var _b = (0, react_i18next_1.useTranslation)(), translate = _b.t, i18n = _b.i18n;
    var namespace = (0, hook_1.useNamespace)();
    if (children === undefined) {
        return null;
    }
    var translations = Object.keys(idsAndDefaultValues).reduce(function (memo, key) {
        var _a;
        return (__assign(__assign({}, memo), (_a = {}, _a[key] = translate(key, __assign({ defaultValue: idsAndDefaultValues[key], i18n: i18n, ns: namespace }, variables)), _a)));
    }, {});
    return React.createElement(React.Fragment, null, children(translations));
};
exports.LocalizedDictionary = LocalizedDictionary;
